export const ROLES = {
  admin: "Admin",
  ticket: {
    roles: {
      view: "TICKET_VIEW",
      select: "TICKET_SELECT",
      comment: "TICKET_COMMENT",
      note: "TICKET_NOTE",
      edit: "TICKET_EDIT",
    },
    asset: {
      view: "TICKET_ASSET_VIEW",
      download: "TICKET_ASSET_DOWNLOAD",
    },
    submissions: {
      view: "TICKET_SUBMISSION_VIEW",
      create: "TICKET_SUBMISSION_CREATE",
      edit: "TICKET_SUBMISSION_EDIT",
    },
    billing: {
      view: "TICKET_BILLING_VIEW",
      build: "TICKET_BILLING_EDIT",
    },
    build: {
      view: "TICKET_BUILD_VIEW",
      build: "TICKET_BUILD_EDIT",
    },
    views: {
      submissions: "TICKET_SUBMISSION_VIEW",
    },
    export: {
      acceptReject: "TICKET_EXPORT_ACCEPT_REJECT",
    },
    types: {
      allocation: "TICKET_TYPE_ALLOCATION",
      porting: "TICKET_TYPE_PORTING",
      assignment: "TICKET_TYPE_ASSIGNMENT",
      export: "TICKET_TYPE_EXPORT",
      globalNumber: "TICKET_TYPE_GLOBAL_NUMBER",
      migration: "TICKET_TYPE_MIGRATION",
    },
  },
  billing: {
    roles: {
      view: "BILLING_VIEW",
    },
    rates: {
      roles: {
        view: "RATING_TABLE_VIEW",
        select: "RATING_TABLE_SELECT",
        edit: "RATING_TABLE_EDIT",
        create: "RATING_TABLE_CREATE",
        delete: "RATING_TABLE_DELETE",
        clone: "RATING_TABLE_CLONE",
      },
    },
    products: {
      roles: {
        view: "PRODUCT_TABLE_VIEW",
        select: "PRODUCT_TABLE_SELECT",
        edit: "PRODUCT_TABLE_EDIT",
        create: "PRODUCT_TABLE_CREATE",
        delete: "PRODUCT_TABLE_DELETE",
        clone: "PRODUCT_TABLE_CLONE",
      },
    },
    codes: {
      roles: {
        view: "CODE_DECK_VIEW",
        select: "CODE_DECK_SELECT",
        edit: "CODE_DECK_EDIT",
        create: "CODE_DECK_CREATE",
        delete: "CODE_DECK_DELETE",
        clone: "CODE_DECK_CLONE",
      },
    },
  },
  globalNumber: {
    roles: {
      view: "GLOBAL_NUMBER_VIEW",
      edit: "GLOBAL_NUMBER_SELECT",
      delete: "GLOBAL_NUMBER_DELETE",
    },
  },
  config: {
    roles: {
      view: "CONFIG_VIEW",
    },
    region: {
      roles: {
        view: "REGION_VIEW",
        edit: "REGION_SELECT",
        delete: "REGION_DELETE",
        create: "REGION_CREATE",
      },
    },
  },
  security: {
    roles: {
      view: "SECURITY_VIEW",
    },
    role: {
      roles: {
        view: "ROLE_VIEW",
        select: "ROLE_SELECT",
        edit: "ROLE_EDIT",
        create: "ROLE_CREATE",
        delete: "ROLE_DELETE",
      },
    },
    permission: {
      roles: {
        view: "PERMISSION_VIEW",
        select: "PERMISSION_SELECT",
        edit: "PERMISSION_EDIT",
        create: "PERMISSION_CREATE",
        delete: "PERMISSION_DELETE",
      },
    },
  },
  organisation: {
    roles: {
      view: "ORGANISATION_VIEW",
      select: "ORGANISATION_SELECT",
      edit: "ORGANISATION_EDIT",
      create: "ORGANISATION_CREATE",
      delete: "ORGANISATION_DELETE",
    },
    user: {
      roles: {
        view: "ORGANISATION_USER_VIEW",
        select: "ORGANISATION_USER_SELECT",
        edit: "ORGANISATION_USER_EDIT",
        create: "ORGANISATION_USER_CREATE",
        delete: "ORGANISATION_USER_DELETE",
      },
    },
    role: {
      roles: {
        view: "ORGANISATION_ROLE_VIEW",
        assign: "ORGANISATION_ROLE_ASSIGN",
        revoke: "ORGANISATION_ROLE_REVOKE",
      },
    },
    charge: {
      roles: {
        view: "ORGANISATION_CHARGE_VIEW",
        select: "ORGANISATION_CHARGE_SELECT",
        download: "ORGANISATION_CHARGE_DOWNLOAD",
      },
    },
    product: {
      roles: {
        view: "ORGANISATION_PRODUCT_TABLE_DOWNLOAD",
      },
    },
    rate: {
      roles: {
        view: "ORGANISATION_RATING_TABLE_DOWNLOAD",
      },
    },
  },
  account: {
    roles: {
      view: "ACCOUNT_VIEW",
      select: "ACCOUNT_SELECT",
      edit: "ACCOUNT_EDIT",
      create: "ACCOUNT_CREATE",
      delete: "ACCOUNT_DELETE",
    },
    flow: {
      roles: {
        view: "FLOW_VIEW",
      },
    },
    events: {
      roles: {
        view: "EVENT_VIEW",
        select: "EVENT_SELECT",
      },
      recording: {
        roles: {
          view: "RECORDING_VIEW",
          download: "RECORDING_DOWNLOAD",
          play: "RECORDING_PLAY",
          restore: "RECORDING_RESTORE",
        },
      },
      cdr: {
        roles: {
          view: "EVENT_CDR_VIEW",
          cost: "EVENT_CDR_COST",
        },
      },
      tags: {
        roles: {
          view: "EVENT_TAGS_VIEW",
        },
      },
      debug: {
        roles: {
          view: "EVENT_SEQUENCE",
          pcap: "EVENT_PCAP",
        },
      },
    },
    settings: {
      roles: {
        view: "SETTINGS_VIEW",
      },
      general: {
        roles: {
          edit: "SETTINGS_EDIT_GENERAL",
        },
      },
      address: {
        roles: {
          edit: "SETTINGS_EDIT_ADDRESS",
        },
      },
      locale: {
        roles: {
          edit: "SETTINGS_EDIT_LOCALE",
        },
      },
      voiceCluster: {
        roles: {
          edit: "SETTINGS_EDIT_VOICE_CLUSTER",
        },
      },
      recording: {
        roles: {
          edit: "SETTINGS_EDIT_RECORDING",
        },
      },
      concurrency: {
        roles: {
          edit: "SETTINGS_EDIT_CONCURRENCY",
        },
      },
      teams: {
        roles: {
          edit: "SETTINGS_EDIT_TEAMS",
        },
      },
    },
    device: {
      inbound: {
        roles: {
          view: "INBOUND_FLOW_VIEW",
          select: "INBOUND_FLOW_SELECT",
          edit: "INBOUND_FLOW_EDIT",
          create: "INBOUND_FLOW_CREATE",
          delete: "INBOUND_FLOW_DELETE",
        },
      },
      outbound: {
        roles: {
          view: "OUTBOUND_FLOW_VIEW",
          select: "OUTBOUND_FLOW_SELECT",
          edit: "OUTBOUND_FLOW_EDIT",
          create: "OUTBOUND_FLOW_CREATE",
          delete: "OUTBOUND_FLOW_DELETE",
        },
      },
      subflow: {
        roles: {
          view: "SUBFLOW_FLOW_VIEW",
          select: "SUBFLOW_FLOW_SELECT",
          edit: "SUBFLOW_FLOW_EDIT",
          create: "SUBFLOW_FLOW_CREATE",
          delete: "SUBFLOW_FLOW_DELETE",
        },
      },
      ddi: {
        roles: {
          view: "DDI_VIEW",
          select: "DDI_SELECT",
          release: "DDI_RELEASE",
          pool: "DDI_POOL",
          allocate: "DDI_ALLOCATE",
          import: "DDI_IMPORT",
        },
      },
      trunk: {
        roles: {
          view: "TRUNK_VIEW",
          select: "TRUNK_SELECT",
          edit: "TRUNK_EDIT",
          create: "TRUNK_CREATE",
          delete: "TRUNK_DELETE",
        },
      },
      hook: {
        roles: {
          view: "HOOK_VIEW",
          select: "HOOK_SELECT",
          edit: "HOOK_EDIT",
          create: "HOOK_CREATE",
          delete: "HOOK_DELETE",
        },
      },
      asset: {
        roles: {
          view: "ASSET_VIEW",
          select: "ASSET_SELECT",
          edit: "ASSET_EDIT",
          create: "ASSET_CREATE",
          delete: "ASSET_DELETE",
        },
      },
      play: {
        roles: {
          view: "PLAY_VIEW",
          select: "PLAY_SELECT",
          edit: "PLAY_EDIT",
          create: "PLAY_CREATE",
          delete: "PLAY_DELETE",
        },
      },
      say: {
        roles: {
          view: "SAY_VIEW",
          select: "SAY_SELECT",
          edit: "SAY_EDIT",
          create: "SAY_CREATE",
          delete: "SAY_DELETE",
        },
      },

      remote: {
        roles: {
          view: "REMOTE_VIEW",
          select: "REMOTE_SELECT",
          edit: "REMOTE_EDIT",
          create: "REMOTE_CREATE",
          delete: "REMOTE_DELETE",
        },
      },
      client: {
        roles: {
          view: "CLIENT_VIEW",
          select: "CLIENT_SELECT",
          edit: "CLIENT_EDIT",
          create: "CLIENT_CREATE",
          delete: "CLIENT_DELETE",
        },
      },
      sipExtension: {
        roles: {
          view: "SIP_EXTENSION_VIEW",
          select: "SIP_EXTENSION_SELECT",
          edit: "SIP_EXTENSION_EDIT",
          create: "SIP_EXTENSION_CREATE",
          delete: "SIP_EXTENSION_DELETE",
        },
      },
      sipGateway: {
        roles: {
          view: "SIP_GATEWAY_VIEW",
          select: "SIP_GATEWAY_SELECT",
          edit: "SIP_GATEWAY_EDIT",
          create: "SIP_GATEWAY_CREATE",
          delete: "SIP_GATEWAY_DELETE",
        },
      },
      teams: {
        roles: {
          view: "TEAMS_VIEW",
          select: "TEAMS_SELECT",
          edit: "TEAMS_EDIT",
          create: "TEAMS_CREATE",
          delete: "TEAMS_DELETE",
        },
      },
      huntGroup: {
        roles: {
          view: "HUNT_GROUP_VIEW",
          select: "HUNT_GROUP_SELECT",
          edit: "HUNT_GROUP_EDIT",
          create: "HUNT_GROUP_CREATE",
          delete: "HUNT_GROUP_DELETE",
        },
      },
      queue: {
        roles: {
          view: "QUEUE_VIEW",
          select: "QUEUE_SELECT",
          edit: "QUEUE_EDIT",
          create: "QUEUE_CREATE",
          delete: "QUEUE_DELETE",
        },
      },
      voicemail: {
        roles: {
          view: "VOICEMAIL_VIEW",
          select: "VOICEMAIL_SELECT",
          edit: "VOICEMAIL_EDIT",
          create: "VOICEMAIL_CREATE",
          delete: "VOICEMAIL_DELETE",
        },
      },
      aniRouter: {
        roles: {
          view: "ANI_ROUTER_VIEW",
          select: "ANI_ROUTER_SELECT",
          edit: "ANI_ROUTER_EDIT",
          create: "ANI_ROUTER_CREATE",
          delete: "ANI_ROUTER_DELETE",
        },
      },
      dnisRouter: {
        roles: {
          view: "DNIS_ROUTER_VIEW",
          select: "DNIS_ROUTER_SELECT",
          edit: "DNIS_ROUTER_EDIT",
          create: "DNIS_ROUTER_CREATE",
          delete: "DNIS_ROUTER_DELETE",
        },
      },
      regionRouter: {
        roles: {
          view: "REGION_ROUTER_VIEW",
          select: "REGION_ROUTER_SELECT",
          edit: "REGION_ROUTER_EDIT",
          create: "REGION_ROUTER_CREATE",
          delete: "REGION_ROUTER_DELETE",
        },
      },
      digits: {
        roles: {
          view: "DIGITS_VIEW",
          select: "DIGITS_SELECT",
          edit: "DIGITS_EDIT",
          create: "DIGITS_CREATE",
          delete: "DIGITS_DELETE",
        },
      },
      dayOfWeek: {
        roles: {
          view: "DOW_VIEW",
          select: "DOW_SELECT",
          edit: "DOW_EDIT",
          create: "DOW_CREATE",
          delete: "DOW_DELETE",
        },
      },
      dateRange: {
        roles: {
          view: "DATE_RANGE_VIEW",
          select: "DATE_RANGE_SELECT",
          edit: "DATE_RANGE_EDIT",
          create: "DATE_RANGE_CREATE",
          delete: "DATE_RANGE_DELETE",
        },
      },
      timeRange: {
        roles: {
          view: "TIME_RANGE_VIEW",
          select: "TIME_RANGE_SELECT",
          edit: "TIME_RANGE_EDIT",
          create: "TIME_RANGE_CREATE",
          delete: "TIME_RANGE_DELETE",
        },
      },
      plugin: {
        roles: {
          view: "PLUGIN_VIEW",
          select: "PLUGIN_SELECT",
          edit: "PLUGIN_EDIT",
          create: "PLUGIN_CREATE",
          delete: "PLUGIN_DELETE",
        },
      },
      script: {
        roles: {
          view: "SCRIPT_VIEW",
          select: "SCRIPT_SELECT",
          edit: "SCRIPT_EDIT",
          create: "SCRIPT_CREATE",
          delete: "SCRIPT_DELETE",
        },
      },
    },
  },
};
